export default {
  shipping: {
    id: 'checkout_summary_shipping',
    defaultMessage: 'Shipping',
  },
  free: {
    id: 'checkout_summary_free',
    defaultMessage: 'Free',
  },
  mobilePlanSubsidy: {
    id: 'checkout_mobile_plan_subsidy',
    defaultMessage: '{partnerName} saved you {subsidy}',
  },
}
